export default __webpack_public_path__ + "09270c246ba20758b3153d8c295dd18a.exr";